import React, { useMemo } from 'react'
import { StyleSheet, View } from 'react-native'
import BuilderBottomModal from '../../../../../ui/molecules/BuilderBottomModal'
import { useTranslation } from 'react-i18next'

import { BankAccountPaymentMethods } from '@linqpal/models/src/dictionaries'
import { AddNewButton } from '../../../../../ui/add-payment-method-components'
import { PaymentMethodItem } from '../../Invoice/components'
import { BtText, Spacer } from '@linqpal/components/src/ui'
import { Spinner } from '../../../../../ui/atoms/Spinner'

export const ChoosePaymentMethodBottomModal = ({
  paymentMethods,
  arePaymentMethodsLoading,
  cardPaymentAvailable,
  acceptAchPayment,
  onAddNewPaymentMethod,
  onPayWithBankOrCard,
  onClose,
}) => {
  const { t } = useTranslation('global')

  const filteredPaymentMethods = useMemo(() => {
    if (!paymentMethods) {
      return []
    }

    return paymentMethods.filter((acc: any) => {
      if (
        acc.paymentMethodType === BankAccountPaymentMethods.Bank &&
        !acceptAchPayment
      ) {
        return false
      }
      if (
        acc.paymentMethodType !== BankAccountPaymentMethods.Bank &&
        !cardPaymentAvailable
      ) {
        return false
      }
      return true
    })
  }, [paymentMethods, acceptAchPayment, cardPaymentAvailable])

  return (
    <BuilderBottomModal
      visible={true}
      onClose={onClose}
      footer={<View style={{ height: 60 }} />}
      height={600}
      width={650}
    >
      {arePaymentMethodsLoading ? (
        <View style={{ height: '100%', width: '100%' }}>
          <Spinner size="large" status="primary" style={styles.spinner} />
        </View>
      ) : (
        <View style={styles.methodsContainer}>
          <BtText style={styles.title}>
            {t('PaymentHistoryInvoice.choosePaymentMethod')}
          </BtText>
          {filteredPaymentMethods.map((acc, i) => (
            <PaymentMethodItem
              key={i}
              item={acc}
              disabled={false}
              onPaymentSelection={onPayWithBankOrCard}
            />
          ))}

          <AddNewButton
            onPress={onAddNewPaymentMethod}
            disabled={false}
            showArrow={false}
          />

          <Spacer height={43} />
        </View>
      )}
    </BuilderBottomModal>
  )
}

const styles = StyleSheet.create({
  spinner: {
    marginTop: 200,
    zIndex: 200,
  },
  methodsContainer: {
    marginTop: 30,
    width: 350,
    alignSelf: 'center',
  },
  title: {
    fontSize: 24,
    fontWeight: '600',
    lineHeight: 28,
    color: '#001929',
    marginBottom: 30,
    letterSpacing: 0.2,
    textAlign: 'center',
    fontFamily: 'Inter',
  },
})
